export default __webpack_public_path__ + "static/media/icon-infobox.bed00d45.svg";